export interface EVisitorIntegrationModel {
  id: number;
  name: string;
}

export type EVisitorView = {
  id: number;
  facility: string;
  user: string;
  numberOfUnits: number;
  numberOfBeds: number;
  defaultNumberOfExtraBeds: number | null;
  accountName: string;
  autoCheckout: boolean;
  statusId: number | null;
};

export class EVisitorModel {
  id = 0;
  propertyId = 0;
  facility = "";
  user = "";
  password = null as string | null;
  numberOfUnits = 0;
  numberOfBeds = 0;
  defaultNumberOfExtraBeds = null as number | null;
  accountName = "";
  autoCheckout = false;
  statusId: number | null = null;
}

export type EVisitorGridViewModel = {
  id: number;

  customerName: string;
  identificationDocumentTypeId?: number;
  identificationDocumentNumber: string;
  dateOfBirth?: string;
  countryOfBirthId?: number;
  countryOfResidenceId?: number;
  citizenshipId?: number;
  genderId: number;

  propertyName: string;
  accomodationUnitTypeName: string;
  accomodationUnitName: string;
  reservationId: number;
  arrivalDate: string;
  arrivalTime: string;
  departureDate: string;
  departureTime: string;
  eVisitorPaymentCategoryId: number;
  eVisitorPaymentCategory: string;
  eVisitorArrivalOrganizationTypeId: number;
  eVisitorArrivalOrganizationType: string;
  magicalField: number;

  eVisitorStatusId: EVisitorStatusEnum;
  eVisitorValidationMessages: string[];

  isSelfCheckIn?: boolean;
};

export enum EVisitorStatusEnum {
  NotCheckedIn = 1,
  CheckedIn = 2,
  CheckedOut = 3,
}
